import React, { ReactElement } from 'react';

interface ListPageWithFiltersProps {
  sideBar: ReactElement;
  mainContent: ReactElement;
}

export default function PageWithSidebar({ sideBar, mainContent }: ListPageWithFiltersProps): ReactElement {
  return (
    <div className="clearfix">
      <div id="sidebar-first-spacer" className="sidebar-spacer">
        <div id="sidebar-first" className="sidebar sticky">
          <aside className="sidebar-first" role="complementary">
            {sideBar}
          </aside>
        </div>
      </div>
      <main role="main" className="main-content main ts-list-page-main">
        {mainContent}
      </main>
    </div>
  );
}
